<template>
    <v-card v-if="!asButton" link tile flat class="sidenav card" :class="{ 'is-active': isActive }" :to="route">
        <div class="sidenav-content">
            <v-badge v-if="hasCount" :color="countColor" :content="count" :offset-y="8" :offset-x="4">
                <v-icon size="24">{{ icon }}</v-icon>
            </v-badge>
            <v-icon v-else size="24">{{ icon }}</v-icon>
            <div class="sidenav-title" v-text="title"></div>
        </div>
    </v-card>

    <v-btn v-else :to="route" class="bottombar_btn">
        <span>{{ title }}</span>
        <v-badge v-if="hasCount" :color="countColor" :content="count" :offset-y="8" :offset-x="4">
            <v-icon>{{ icon }}</v-icon>
        </v-badge>
        <v-icon v-else>{{ icon }}</v-icon>
    </v-btn>
</template>


<script>
export default {
    name: 'NavTile',
    props: {
        title: String,
        icon: String,
        route: [Object, String],
        count: [Number, String],
        countColor: {
            type: String,
            default: 'primary',
        },
        asButton: Boolean,
    },
    components: {},

    data() {
        return {};
    },

    methods: {},

    computed: {
        hasCount() {
            return Number(this.count) > 0;
        },
        isActive() {
            if (!this.route || !this.$router || !this.$route) {
                return false;
            }

            const resolved = this.$router.resolve(this.route);
            const target = resolved?.route;
            if (!target) {
                return false;
            }

            if (target.name && this.$route.name) {
                return target.name === this.$route.name;
            }

            return target.path === this.$route.path;
        },
    },

    watch: {},
};
</script>


<style lang='scss' scoped>

.sidenav.card {
    border-left: 4px solid transparent;
    border-radius: 0;
    color: rgba(0, 0, 0, 0.78);
    opacity: 0.9;
    transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.sidenav-content {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: center;
    min-height: 86px;
    padding: 12px 6px;
}

.sidenav-title {
    font-size: 0.86rem;
    line-height: 1.2;
    max-width: 100%;
    overflow-wrap: anywhere;
    text-align: center;
}

.sidenav.card:hover {
    background-color: rgba(63, 81, 181, 0.06) !important;
}

.sidenav.card.is-active {
    background-color: rgba(var(--v-theme-primary), 0.1) !important;
    border-left-color: rgb(var(--v-theme-primary));
    opacity: 1;
    color: rgb(var(--v-theme-primary));
}


.bottombar_btn {
    color: var(--v-primary-darken2) !important;
}
.theme--light.v-bottom-navigation .v-btn:not(.v-btn--active) {
    color: var(--v-bottombar-base) !important;
    opacity: 0.7 !important;
}
</style>